import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { NavDropdownProps } from "../../@types/Navbar";

function NavbarDropdown({
  subLinks,
  triggerButtonProps,
  label,
  routeChangeFn,
  isLoggedIn,
}: NavDropdownProps) {
  return (
    <Menu>
      <>
        <MenuButton
          as={Button}
          _active={{
            color: "primary.500",
          }}
          {...triggerButtonProps}
        >
          {label}
        </MenuButton>
        <MenuList zIndex={1000}>
          {subLinks?.map((item, index) => {
            if (item?.authRequired && !isLoggedIn) return null;
            return (
              <MenuItem
                _hover={{
                  color: "primary.500",
                  backgroundColor: "gray.50",
                }}
                onClick={() => {
                  item.href && routeChangeFn(item.href);
                }}
                key={`nav_sub_link_${index}`}
              >
                {item.label}
              </MenuItem>
            );
          })}
        </MenuList>
      </>
    </Menu>
  );
}

export default NavbarDropdown;
